import Helmet from 'react-helmet';
import { Button, Checkbox, Icon, InputInLabel, Loader } from '@/components/ui';

import { useState, useEffect } from 'react';
import { makeRequest } from '@/services/makeRequest';
import { Link } from 'react-router-dom';

import showToast from '../../toast/Toast';

import './linkWithAgencyPopup.scss';
import useLadyService from '../../../services/LadyService';
import { Popup } from '../index';

const Res = ({ isLoading, agencyOptions, value, handleAddChange, search }) => {
	const { t, setMediaSize, lang } = useLadyService();

	switch (true) {
		case isLoading: {
			return <Loader />;
		}

		case !!agencyOptions.length: {
			return agencyOptions.map((i) => {
				const { logo, id, name, slug: slugAgency } = i;

				return (
					<div
						key={id}
						className="agency-block"
					>
						<Link
							className="agency-block__link-to"
							target="_blank"
							to={`/${lang}/agency/${id}`}
						>
							<img
								src={setMediaSize(logo, 'xs')}
								alt={t('"agencybrothel"')}
							/>
							<p className="p-el-1row">{name}</p>
						</Link>
						<Checkbox
							border={false}
							checked={slugAgency === value}
							onChange={() =>
								handleAddChange(slugAgency, name, id)
							}
						/>
					</div>
				);
			});
		}

		case !!search && !!agencyOptions.length: {
			return (
				<span className="w-100 text-center">{t('startagency')}</span>
			);
		}

		case !!search && !agencyOptions.length: {
			return (
				<span className="w-100 text-center">{t('noproffound')}</span>
			);
		}

		default: {
			return (
				<span className="w-100 text-center">{t('startagency')}</span>
			);
		}
	}
};

const LinkWithAgencyPopup = (props) => {
	const {
		open,
		setOpen,
		slug: slugProfile,
		setLinked = false,
		agencyLinked = false,
	} = props;
	const { token, lang, t } = useLadyService();

	const [agencyOptions, setAgencyOptions] = useState([]);

	const [value, setValue] = useState(null);
	const [isLoading, seiIsLoading] = useState(false);

	const [search, setSearch] = useState('');

	const onClose = () => {
		setValue(null);
		setOpen(false);
	};

	const handleAddChange = (slugAgency, name, id) => {
		if (slugAgency === value) {
			setValue(null);
		} else {
			setValue(slugAgency);
		}
	};

	const handleFilter = (e) => {
		const val = e.currentTarget.value;
		setSearch(val);
	};

	const onSubmit = (e) => {
		e.preventDefault();
		const fetchData = async () => {
			try {
				const route = `user/profile/${slugProfile}/add-agency`;
				const method = 'POST';
				const payload = {
					agency: value,
				};

				await makeRequest({ route, method, payload });
				const agency = agencyOptions.filter((agency) => {
					if (agency.slug === value) {
						return agency;
					}
				})[0];
				setLinked({ name: agency.name, id: agency.id });
				onClose();
				showToast({
					message: t('success'),
					variant: 'success',
				});
			} catch (error) {
				showToast({
					message: t('oops'),
					variant: 'error',
				});
				setLinked(false);
			}
		};

		fetchData();
	};

	const handleRemoveAgency = async () => {
		try {
			const route = `user/profile/${slugProfile}/remove-agency`;

			const method = 'DELETE';

			await makeRequest({ route, method });

			showToast({
				message: t('success'),
				variant: 'success',
			});
			setLinked(false);
			onClose();
		} catch (error) {
			showToast({
				message: t('oops'),
				variant: 'error',
			});
		}
	};

	const getAgencies = async (payload = {}) => {
		try {
			seiIsLoading(true);
			const route = `agencies`;
			const method = 'GET';
			const payload = {
				search,
			};

			const { agencies } = await makeRequest({ route, method, payload });
			setAgencyOptions(agencies);
			seiIsLoading(false);
		} catch (error) {
			showToast({ message: 'oops', variant: 'error' });
			seiIsLoading(false);
		}
	};

	useEffect(() => {
		!!search && token && getAgencies({ search });
	}, [token, lang, search]);

	useEffect(() => {
		getAgencies({ limit: 5 });
	}, []);

	return (
		<Popup
			open={open}
			setOpen={onClose}
			onSubmit={onSubmit}
			clazz={'gap-24'}
		>
			<h2>{t('connectagency')}</h2>
			<span className={'p text-center color-main'}>
				{t('linkagencyinfo')}
			</span>

			<InputInLabel
				clazz={'br-24 p-h-24'}
				placeholder={t('searchagency')}
				onChange={handleFilter}
				value={search}
				size={'s'}
			/>

			<div className="agency-block__content">
				<Res
					isLoading={isLoading}
					agencyOptions={agencyOptions}
					value={value}
					handleAddChange={handleAddChange}
					search={search}
				/>
			</div>

			{agencyLinked && (
				<Button
					size={'l'}
					disabled={value}
					onClick={() => handleRemoveAgency()}
					clazz={'button--error justify-center'}
				>
					{t('disconnect')}
				</Button>
			)}

			<Button
				size={'l'}
				disabled={!value}
				buttonType={'submit'}
				clazz={'button--green justify-center'}
			>
				{t('confirm')}
			</Button>
		</Popup>
	);
};

export default LinkWithAgencyPopup;
